// Commercial — BarChart horizontal des taux de conversion par visiteur.
import { Loader2 } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { useCommercialFetch } from "./useCommercialFetch";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg px-3 py-2 text-xs shadow-xl border"
      style={{ background: "var(--oh-bg-elevated)", borderColor: "var(--oh-border)", color: "var(--oh-text)" }}>
      <p className="font-semibold mb-1">{payload[0]?.payload?.visiteur}</p>
      {payload.map((e, i) => (
        <p key={i} style={{ color: e.color || e.fill }}>
          {e.name}: <span className="font-bold">{e.value}%</span>
        </p>
      ))}
    </div>
  );
};

export default function CommercialTauxVisiteursWidget() {
  const { data, loading, error } = useCommercialFetch();

  if (loading) {
    return (
      <div className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error || !data) {
    return (
      <div className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}>
        Erreur Taux par visiteur : {error || "—"}
      </div>
    );
  }

  const barData = (data.par_visiteur || []).map((v) => ({
    visiteur: v.visiteur,
    "Dépôt": v.taux_depot,
    "Octroi": v.taux_octroi,
    "Clôture": v.taux_cloture,
  }));

  if (!barData.length) {
    return (
      <div className="rounded-xl p-5 h-full text-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}>
        Aucun visiteur à afficher.
      </div>
    );
  }

  return (
    <div className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="commercial-taux-visiteurs-widget">
      <h3 className="text-base font-semibold mb-4" style={{ color: "var(--oh-text)" }}>
        Taux de conversion par visiteur
      </h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={barData} layout="vertical" margin={{ left: 10, right: 20 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--oh-border)" />
            <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`}
              tick={{ fill: "var(--oh-text-muted)", fontSize: 11 }} />
            <YAxis type="category" dataKey="visiteur" width={80}
              tick={{ fill: "var(--oh-text)", fontSize: 12 }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend verticalAlign="top" align="right" iconType="square" iconSize={10}
              wrapperStyle={{ fontSize: "12px", color: "var(--oh-text-muted)", paddingBottom: "8px" }} />
            <Bar dataKey="Dépôt" fill="#8B5CF6" radius={[0, 2, 2, 0]} barSize={14} name="Dépôt ANAH" />
            <Bar dataKey="Octroi" fill="#10B981" radius={[0, 2, 2, 0]} barSize={14} name="Octroi" />
            <Bar dataKey="Clôture" fill="var(--oh-stat-green-text)" radius={[0, 2, 2, 0]} barSize={14} name="Clôture" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
